// ********  resize la map en fonction du bloc formulaire
$(window).load(function(){
  if(window.innerWidth > 992){
    function resizeMap(){
      var formHeight = $('.contactus-form').outerHeight();

      var mapHeight = formHeight * (3/4);
      $('.contactus-map').height(mapHeight);
      var ecart = formHeight - mapHeight - 1;
      $('.contactus-info').innerHeight(ecart);
    }

    resizeMap();
    $( window ).resize(function() {
      resizeMap();
    });
  }
});


var position = [43.52117, 1.513367];
var map;

function showGoogleMaps() {

  var latLng = new google.maps.LatLng(position[0], position[1]);
  var centermapLatLng = new google.maps.LatLng(43.52117, 1.513367);


  var styles = [
  {
    "featureType": "landscape",
    "stylers": [
    { "visibility": "on" },
    { "color": "#f9f9f9" }
    ]
  },{
    "featureType": "road",
    "stylers": [
    { "visibility": "on" },
    { "color": "#ffffff" }
    ]
  },{
    "featureType": "road",
    "elementType": "labels.text.fill",
    "stylers": [
    { "visibility": "on" },
    { "color": "#bab9b9" }
    ]
  },{
    "featureType": "water",
    "elementType": "geometry",
    "stylers": [
    { "visibility": "on" },
    { "color": "#efefef" }
    ]
  },{
    "featureType": "poi",
    "stylers": [
    { "visibility": "on" },
    { "color": "#e6e6e6" }
    ]
  },{
    "featureType": "poi",
    "elementType": "labels.text.stroke",
    "stylers": [
    { "visibility": "off" }
    ]
  },{
    "featureType": "road",
    "elementType": "labels",
    "stylers": [
    { "visibility": "on" }
    ]
  },{
    "featureType": "administrative",
    "elementType": "labels.text.stroke",
    "stylers": [
    { "color": "#f12c80" },
    { "visibility": "off" }
    ]
  },{
    "featureType": "administrative",
    "elementType": "labels.text.fill",
    "stylers": [
    { "visibility": "on" },
    { "color": "#808080" }
    ]
  },{
    "featureType": "road.arterial",
    "elementType": "labels.icon",
    "stylers": [
    { "visibility": "off" }
    ]
  },
  {
    "featureType": "administrative.country",
    "elementType": "geometry.stroke",
    "stylers": [
    {
      "color": "#a2a2a2"
    }
    ]
  },{
    "featureType": "road",
    "elementType": "labels.icon",
    "stylers": [
    { "visibility": "on" },
    { "color": "#ffffff" }
    ]
  },{
    "featureType": "administrative",
    "elementType": "labels"  },{
      "featureType": "road",
      "elementType": "labels.icon",
      "stylers": [
      { "visibility": "off" }
      ]
    }
    ];

    var contentString = '<div id="content">'+
    '</div>'+
    '<span style="font-family: azosans-bold; font-size:25px;">GTP Technology</span>'+
    '<p>GTP Technology </br>'+
    'Bâtiment Gould - 52, l\'Occitane  31670 <br/>'+
    'Labège Cedex - France </p>'+
    '</div>';

    var infowindow = new google.maps.InfoWindow({
      content: contentString
    });

    if (window.innerWidth <= 768) {
      var mobileScreen = false;
    } else {
      var mobileScreen = true;
    }

    var mapOptions = {
        zoom: 7, // initialize zoom level - the max value is 21
        streetViewControl: false,
        scaleControl: true,
        scrollwheel: false,
        zoomControl: true,
        mapTypeControl: false,
        disableDefaultUI: true,
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        center: (centermapLatLng)
      };

      map = new google.maps.Map(document.getElementById('contactus-map'),
        mapOptions);

      map.setOptions({styles: styles});
    // Show the default red marker at the location
    marker = new google.maps.Marker({
      position: latLng,
      map: map,
      animation: google.maps.Animation.DROP,
      icon: {
        url:"./public/images/marker.png",
        size: new google.maps.Size(51,67),
        anchor: new google.maps.Point(0,67)
      }
    });

    marker.addListener('click', function() {
      infowindow.open(map, marker);
    });
  }

  google.maps.event.addDomListener(window, 'load', showGoogleMaps);
